import { 
  differenceInYears,
  differenceInMonths,
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
} from "date-fns"
import { Status } from "./definitions"

const LEVEL_COLOR = [
  'rgb(45, 45, 45)',

  'rgb(157, 73, 0)',
  'rgb(165, 79, 0)',
  'rgb(173, 85, 0)',
  'rgb(181, 93, 10)',
  'rgb(198, 119, 57)',

  'rgb(56, 84, 110)',
  'rgb(61, 90, 116)',
  'rgb(67, 95, 122)',
  'rgb(73, 101, 128)',
  'rgb(78, 106, 134)',

  'rgb(210, 133, 0)',
  'rgb(223, 143, 0)',
  'rgb(236, 154, 0)',
  'rgb(249, 165, 24)',
  'rgb(255, 176, 40)',

  'rgb(0, 199, 139)',
  'rgb(0, 212, 151)',
  'rgb(39, 226, 164)',
  'rgb(62, 240, 177)',
  'rgb(81, 253, 189)',

  'rgb(0, 158, 229)',
  'rgb(0, 169, 240)',
  'rgb(0, 180, 252)',
  'rgb(43, 191, 255)',
  'rgb(65, 202, 255)',

  'rgb(224, 0, 76)',
  'rgb(234, 0, 83)',
  'rgb(245, 0, 90)',
  'rgb(255, 0, 98)',
  'rgb(255, 48, 113)',

  'rgb(180, 145, 255)',
]

export const getLevelColor = (level: number) => {
  if (level >= 31) {
      return LEVEL_COLOR[31]
  }
  return LEVEL_COLOR[level]
}

const LEVEL_GRAPH_COLOR = [
  'rgb(45, 45, 45)',

  'rgb(157, 73, 0)',
  'rgb(165, 79, 0)',
  'rgb(173, 85, 0)',
  'rgb(181, 93, 10)',
  'rgb(198, 119, 57)',

  'rgb(56, 84, 110)',
  'rgb(61, 90, 116)',
  'rgb(67, 95, 122)',
  'rgb(73, 101, 128)',
  'rgb(78, 106, 134)',

  'rgb(210, 133, 0)',
  'rgb(223, 143, 0)',
  'rgb(236, 154, 0)',
  'rgb(249, 165, 24)',
  'rgb(255, 176, 40)',

  'rgb(0, 199, 139)',
  'rgb(0, 212, 151)',
  'rgb(39, 226, 164)',
  'rgb(62, 240, 177)',
  'rgb(81, 253, 189)',

  'rgb(0, 158, 229)',
  'rgb(0, 169, 240)',
  'rgb(0, 180, 252)',
  'rgb(43, 191, 255)',
  'rgb(65, 202, 255)',

  'rgb(224, 0, 76)',
  'rgb(234, 0, 83)',
  'rgb(245, 0, 90)',
  'rgb(255, 0, 98)',
  'rgb(255, 48, 113)',

  'rgb(179, 0, 224)',
]

export const getGraphColor = (rating: number) => {
  const level = Math.ceil((rating + 0.5) / 100)
  if (level >= 31) {
    return LEVEL_GRAPH_COLOR[31]
  }
  return LEVEL_GRAPH_COLOR[level]
}

const LEVEL_TEXT = [
  'Unrated',

  'Bronze V',
  'Bronze IV',
  'Bronze III',
  'Bronze II',
  'Bronze I',

  'Silver V',
  'Silver IV',
  'Silver III',
  'Silver II',
  'Silver I',

  'Gold V',
  'Gold IV',
  'Gold III',
  'Gold II',
  'Gold I',

  'Platinum V',
  'Platinum IV',
  'Platinum III',
  'Platinum II',
  'Platinum I',

  'Diamond V',
  'Diamond IV',
  'Diamond III',
  'Diamond II',
  'Diamond I',

  'Ruby V',
  'Ruby IV',
  'Ruby III',
  'Ruby II',
  'Ruby I',
]

export const getLevelText = (level: number) => {
  return LEVEL_TEXT[level]
}

export const getLowLevelByRating = (rating: number) => {
  const diff = 200;
  return Math.max(Math.round((rating - diff) / 100), 1);
};

export const getStatusColor = (status: Status) => {
  switch (status) {
    case Status.ACCEPTED:
      return 'green'
    case Status.PASSED:
      return 'red'
    case Status.WAITING:
      return 'gray'
    case Status.NONE:
      return 'black'
  }
}

export const getLastTime = (date: Date) => {
  const year = differenceInYears(new Date(), date)
  if (year > 0) {
    return `${year}년 전`
  }
  const month = differenceInMonths(new Date(), date)
  if (month > 0) {
    return `${month}개월 전`
  }
  const day = differenceInDays(new Date(), date)
  if (day > 0) {
    return `${day}일 전`
  }
  const hour = differenceInHours(new Date(), date)
  if (hour > 0) {
    return `${hour}시간 전`
  }
  const minute = differenceInMinutes(new Date(), date)
  if (minute > 0) {
    return `${minute}분 전`
  }
  const second = differenceInSeconds(new Date(), date)
  return `${second}초 전`
}

export const getElapsedTime = (date: Date) => {
  const diff = new Date().getTime() - new Date(date).getTime()
  const minute = Math.floor(diff / 1000 / 60)
  const second = Math.floor(diff / 1000) % 60
  return `${minute}분 ${second}초`
}